//
//  DocumentationLegacyPageBlockGuideline.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//  Copyright © 2021 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
import { DocumentationLegacyPageBlockFigmaComponentsConfig, DocumentationLegacyPageBlockSelectedFigmaComponent, } from "./SDKDocumentationLegacyPageBlockFigmaComponentsConfig";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockFigmaComponentPropsTable extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.figmaComponentsBlockConfig =
            new DocumentationLegacyPageBlockFigmaComponentsConfig(model.figmaComponentsBlockConfig);
        this.selectedFigmaComponent = model.selectedFigmaComponent
            ? new DocumentationLegacyPageBlockSelectedFigmaComponent(model.selectedFigmaComponent)
            : null;
    }
}
